import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedReturnModalLoader from '../PdpSharedModals/PdpSharedReturnModal/PdpSharedReturnModalLoader';
import { viewDetails } from '../pdpMessages';

// helpers
import get from 'lodash.get';
import tracking from 'dibs-tracking';

// styles
import styles from './PdpSharedDetail.scss';

export class PdpSharedDetailReturnPolicy extends React.Component {
    constructor(props) {
        super(props);

        this.state = { modalOpen: false };
        this.onClick = this.onClick.bind(this);
        this.onClose = this.onClose.bind(this);
    }
    onClick(e) {
        e.preventDefault();

        this.setState({ modalOpen: true }, () => {
            const returnable = get(this.props, 'item.returnPolicy.accept');

            tracking.trackEvent({
                category: 'product',
                action: 'view return details',
                label: `pdp description|${
                    returnable ? 'returns accepted' : 'returns not accepted'
                }`,
            });
        });
    }
    onClose() {
        this.setState({ modalOpen: false });
    }
    render() {
        const { modalOpen } = this.state;
        const { userId, itemId, item, relay } = this.props;

        return (
            <span data-tn="pdp-spec-return-policy">
                {/* Item Return Policy */}
                <p className={styles.returnPolicy}>
                    {get(item, 'returnPolicy.buyerCopy.returnCopy')}
                </p>
                {/* View Details */}
                <a href="#return-policy-modal" onClick={this.onClick}>
                    {viewDetails}
                </a>
                {/* Return Policy Modal */}
                <PdpSharedReturnModalLoader
                    itemId={itemId}
                    userId={userId}
                    environment={relay.environment}
                    isOpen={modalOpen}
                    onClose={this.onClose}
                />
            </span>
        );
    }
}

PdpSharedDetailReturnPolicy.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string,
    item: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailReturnPolicy, {
    item: graphql`
        fragment PdpSharedDetailReturnPolicy_item on Item {
            returnPolicy(userId: $userId) {
                accept
                buyerCopy {
                    returnCopy
                }
            }
        }
    `,
});
